<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">
    {{ modalTitle }}
  </h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">

  <!-- Small loader for form content only -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>

    <!-- Partnership/Partner Setup heading -->
    <div class="row">
      <div class="col-md-12">
        <table border="0" width="100%">
          <tr>
            <td style="width:75%"><h4>Partnership/Partner Setup</h4></td>
            @if (PSHIP_INTERNAL_OR_EXTERNAL_INDICATOR === 'Internal') {
<td
                style="width:10%; text-align:right;"
                title="Syncs posting for all partnership feeds for same ME">
              <input type="checkbox"
                     [ngModel]="syncPosting == '1'"
                     (ngModelChange)="syncPosting = $event ? '1' : '0'">
              <b> Sync Posting Partner</b>
            </td>
}
            <td style="width:15%"></td>
          </tr>
        </table>
      </div>
    </div>

    <!-- Partnership Header Information Table -->
    <div style="overflow-x: auto;">
      <table class="table table-bordered custom-table" style="white-space: nowrap;">
        <thead>
          <tr>
            <th rowspan="2">LEID</th>
            <th rowspan="2">Tax Code</th>
            <th rowspan="2">Reporting Period</th>
            <th rowspan="2">Name</th>
            <th rowspan="2">US Tax Type</th>
            <th rowspan="2">ME</th>
            <th rowspan="2">Currency</th>
            <th rowspan="2">Company Code</th>
            <th rowspan="2">HO LEID</th>
            <th rowspan="2">HO Tax Code</th>
            <th rowspan="2">HO Reporting Period</th>
            <th rowspan="2">HO Name</th>
            <th rowspan="2">HO Company Code</th>
            <th rowspan="2">HO US Tax Type</th>
            <th rowspan="2">Tax Year Begin</th>
            <th rowspan="2">Tax Year End</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ PSHIP_LEID }}</td>
            <td>{{ PSHIP_TAX_CODE }}</td>
            <td>{{ PSHIP_REPORTING_PERIOD }}</td>
            <td>{{ PSHIP_NAME }}</td>
            <td>{{ PSHIP_US_TAX_TYPE }}</td>
            <td>{{ PSHIP_BUSINESS }}</td>
            <td>{{ PSHIP_CURRENCY }}</td>
            <td>{{ PSHIP_COMPANY_CODE }}</td>
            <td>{{ PSHIP_HO_LEID }}</td>
            <td>{{ PSHIP_HO_TAX_CODE }}</td>
            <td>{{ PSHIP_HO_REPORTING_PERIOD }}</td>
            <td>{{ PSHIP_HO_NAME }}</td>
            <td>{{ PSHIP_HO_COMPANY_CODE }}</td>
            <td>{{ PSHIP_HO_US_TAX_TYPE }}</td>
            <td>{{ PSHIP_BEGIN_DATE }}</td>
            <td>{{ PSHIP_END_DATE }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Partner List Table -->
    <div style="overflow-x: auto;">
      <table class="table table-bordered custom-table">
        <thead>
          <tr>
            <th rowspan="2">Partner LEID</th>
            <th rowspan="2">Partner Tax Code</th>
            <th rowspan="2">Partner Reporting Period</th>
            <th rowspan="2" style="width:150px;">Partner Name</th>
            <th rowspan="2">Partner US Tax Type</th>
            <th rowspan="2">Effective Ownership %</th>
            <th rowspan="2">Effective Date Begin</th>
            <th rowspan="2">Effective Date End</th>
            <th rowspan="2" style="width:210px;">Partner Home Office<br>LEID/Tax Code/RP/US Tax Type</th>
            <th rowspan="2">Posting Partner Combo<br>LEID/Tax Code/RP/ME/CURR/LEDGER</th>
            @if (PSHIP_INTERNAL_OR_EXTERNAL_INDICATOR === 'Internal') {
<th rowspan="2">Allocation %</th>
}
            <th rowspan="2">Posting Inactive</th>
            <th rowspan="2">Initial K1</th>
            <th rowspan="2">Final K1</th>
          </tr>
        </thead>
        <tbody>
          @for (row of partnerList; track $index; let i = $index) {
<tr>
            <td [title]="row.PARTNER_NAME" style="white-space: nowrap;">{{ row.PARTNER_LEID }}</td>
            <td [title]="row.PARTNER_NAME" style="white-space: nowrap;">{{ row.PARTNER_TAX_CODE }}</td>
            <td [title]="row.PARTNER_NAME" style="white-space: nowrap;">{{ row.PARTNER_REPORTING_PERIOD }}</td>
            <td>{{ row.PARTNER_NAME }}</td>
            <td>{{ row.PARTNER_US_TAX_TYPE }}</td>
            <td align="right" style="white-space: nowrap;">{{ row.EFFECTIVE_OWNERSHIP_PERCENTAGE }}</td>
            <td style="white-space: nowrap;">{{ row.EFFECTIVE_DATE_BEGIN }}</td>
            <td style="white-space: nowrap;">{{ row.EFFECTIVE_DATE_END }}</td>
            <td [title]="row.PARTNER_HO_NAME" style="white-space: nowrap;">
              {{ row.PARTNER_HO_LEID }}/{{ row.PARTNER_HO_TAX_CODE }}/{{ row.PARTNER_HO_REPORTING_PERIOD }}/{{ row.PARTNER_HO_US_TAX_TYPE }}
            </td>
            <td>
              <select [id]="'postingCombo_' + (i + 1)"
                      style="width: 370px;"
                      class="form-control"
                      name="posting_combo"
                      [ngModel]="row.POSTING_COMBO"
                      (ngModelChange)="row.POSTING_COMBO = $event; setPosting(row, i)">
                @for (s of postingLOVArray[i]; track $index) {
<option [value]="s.POSTING_COMBO">
                  {{ s.POSTING_COMBO }}
                </option>
}
              </select>
            </td>
            @if (PSHIP_INTERNAL_OR_EXTERNAL_INDICATOR === 'Internal') {
<td>
              <input type="number"
                     required
                     placeholder="Decimal"
                     pattern="^[0-9]{1,3}(\.[0-9]{0,6})?$"
                     [ngModel]="row.ALLOCATION_PERCENTAGE"
                     (ngModelChange)="row.ALLOCATION_PERCENTAGE = $event; adjustAllocPercentage(row)"
                     class="form-control input-sm"
                     style="text-align: right; width: 100px;">
            </td>
}
            <td>
              <input type="checkbox"
                     [ngModel]="row.IS_INACTIVE == '1' || row.IS_INACTIVE === 1 || row.IS_INACTIVE === true"
                     (ngModelChange)="row.IS_INACTIVE = $event ? '1' : '0'">
            </td>
            <td>
              <input type="checkbox"
                     [ngModel]="row.PTR_K1_INITIAL == '1' || row.PTR_K1_INITIAL === 1 || row.PTR_K1_INITIAL === true"
                     (ngModelChange)="row.PTR_K1_INITIAL = $event ? '1' : '0'">
            </td>
            <td>
              <input type="checkbox"
                     [ngModel]="row.PTR_K1_FINAL == '1' || row.PTR_K1_FINAL === 1 || row.PTR_K1_FINAL === true"
                     (ngModelChange)="row.PTR_K1_FINAL = $event ? '1' : '0'">
            </td>
          </tr>
}

          <!-- Totals row - only for Internal partnerships -->
          @if (PSHIP_INTERNAL_OR_EXTERNAL_INDICATOR === 'Internal') {
<tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td align="right"><strong>Total %</strong></td>
            <td align="right">{{ totalEffectiveOwnershipPercentage | number }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td align="right"><strong>Total %</strong></td>
            <td align="right">{{ totalAllocationPercentage }}</td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
}
        </tbody>
      </table>
    </div>

  </div>
}
</div>

<!-- Standard Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [attr.disabled]="(isSaveClicked || isLocked) ? true : null"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button"
          type="button"
          [attr.disabled]="isLocked ? true : null"
          (click)="reset()">Reset</button>
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>
